import ImminentReminders from 'app/Private/Invoices/ImminentReminders';
import { AiCall, AiCallsIndex } from 'modules/AiCalls/pages';
import { Route, Switch } from 'react-router-dom';
import { FailedRemindersList, Reminder } from './pages';
import { ReminderList } from './pages/RemindersIndex';

export const Reminders = () => (
  <Switch>
    <Route path="/reminders/imminent" component={ImminentReminders} />
    <Route path="/reminders/failed/:id" component={Reminder} />
    <Route path="/reminders/failed" component={FailedRemindersList} />
    <Route path="/reminders/ai-calls/:id" component={AiCall} />
    <Route path="/reminders/ai-calls" component={AiCallsIndex} />
    <Route path="/reminders/:id" component={Reminder} />
    <Route path="/reminders" component={ReminderList} />
  </Switch>
);
